const STORAGE_KEY = 'favorites_shared_collections';
const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/**
 * Pulls the share token out of whatever someone pastes: a full share link
 * (e.g. http://modulmarble.com/selections/view/<uuid>, /shared-selection/<uuid>),
 * a link with a query string or hash, or the bare token itself.
 *
 * @returns {string|null}
 */
export const parseShareToken = (input) => {
    const value = String(input ?? '').trim();
    if (!value) return null;

    const match = value.match(UUID_PATTERN);

    return match ? match[0].toLowerCase() : null;
};

const readStored = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

        return Array.isArray(parsed) ? parsed.filter(entry => entry && typeof entry.token === 'string') : [];
    } catch {
        return [];
    }
};

const writeStored = (collections) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(collections));
    } catch {
        // Storage unavailable (private mode) — the list just won't persist.
    }
};

/**
 * Remembers shared collections this browser has opened, newest first, so a
 * viewer can come back to them from the sidebar.
 */
export const rememberSharedCollection = (collections, { token, name }) => {
    const next = [
        { token, name: name || 'Shared Collection', opened_at: new Date().toISOString() },
        ...collections.filter(entry => entry.token !== token),
    ];
    writeStored(next);

    return next;
};

export const forgetSharedCollection = (collections, token) => {
    const next = collections.filter(entry => entry.token !== token);
    writeStored(next);

    return next;
};

export const loadSharedCollections = readStored;
